import React from "react"



export default function Spinner(props) {
    
    return (
        <div className="spinner-container">
      <div className="loading-spinner">
      </div>
      </div>
    )
}